import React from "react";
import { isNonEmptyArray } from "../../../../../../common/utils";
import { translate } from "../../../../../../common/providers";
import styles from "./Row.module.css";
import { icon, IconComponent } from "../../../../../../common/components";

const HeaderRow = ({ activeSortKey, headers, onClickSort, sortDirection }) => {
	const renderSortIcon = (header) => {
		if (!header?.sortKey) {
			return null;
		}
		if (header.sortKey !== activeSortKey) {
			return <IconComponent className={`${styles.icon} ${styles["icon--inactive"]}`} icon={icon.faSort} />;
		}
		return (
			<IconComponent className={styles.icon} icon={sortDirection === "asc" ? icon.faSortUp : icon.faSortDown} />
		);
	};
	return (
		<div className={styles.headerRow}>
			{isNonEmptyArray(headers) &&
				headers.map((header) => (
					<div
						key={header.name}
						className={styles[header.className]}
						role="presentation"
						onClick={() => onClickSort(header.sortKey)}
					>
						{translate(header.name)}
						{renderSortIcon(header)}
					</div>
				))}
		</div>
	);
};

export default HeaderRow;
